// Real customer reviews published on the business's own site / Yelp profile.
// Source: Smog Check Hut Modesto (yelp.com/biz/smog-check-hut-modesto).
// These are genuine customer testimonials — not fabricated.
export const REVIEWS = [
  {
    name: "Julinda C.",
    date: "Sep 19, 2020",
    rating: 5,
    text: "Great customer service. Hugo is great. I called first, he was very polite and helpful. They had me in and out within 20 minutes. I asked for a copy of my receipt and they gave me 2 copies.",
    text_es: "Excelente servicio al cliente. Hugo es genial. Llamé primero, fue muy amable y servicial. Me atendieron en menos de 20 minutos. Pedí copia de mi recibo y me dieron 2 copias.",
  },
  {
    name: "Robert Lightfoot",
    date: "Jan 23, 2019",
    rating: 5,
    text: "Best smog guy around, no doubt about it. STAR shop and test and repair, he is one of the best at what he does. California smogs and certs — get there early and get out fast. Thanks for many years!",
    text_es: "El mejor en smog, sin duda. Estación STAR de prueba y reparación, es uno de los mejores en lo que hace. Certificaciones de California: llega temprano y sales rápido. ¡Gracias por tantos años!",
  },
  {
    name: "Grecia N.",
    date: "Sep 8, 2020",
    rating: 5,
    text: "I have been coming here for two years in a row for both my vehicles and every time I come here I get friendly, quick, and efficient service.",
    text_es: "Llevo dos años seguidos viniendo aquí con mis dos vehículos y cada vez recibo un servicio amable, rápido y eficiente.",
  },
  {
    name: "Brian Winters",
    date: "Jun 6, 2020",
    rating: 5,
    text: "I took my car to this smog shop and the guy was the best anyone could be — good service. So I went back for a brake and lamp inspection as well. I would recommend this place to anyone needing service. You rock!",
    text_es: "Llevé mi carro a este taller de smog y el señor fue de lo mejor: buen servicio. Regresé también para una inspección de frenos y luces. Recomiendo este lugar a cualquiera. ¡Son geniales!",
  },
  {
    name: "Hannah L.",
    date: "Nov 2, 2020",
    rating: 5,
    text: "I got my car smog checked today. I called this morning to make sure they were ok with walk-in customers. The guy on the phone was really nice.",
    text_es: "Hoy hice el smog de mi carro. Llamé en la mañana para confirmar que aceptaban clientes sin cita. El señor al teléfono fue muy amable.",
  },
  {
    name: "Rita Simonyans",
    date: "Jan 23, 2018",
    rating: 5,
    text: "Good work! Good price! Fast and excellent customer service. I'll be back again! Highly recommend.",
    text_es: "¡Buen trabajo! ¡Buen precio! Servicio rápido y excelente. ¡Volveré! Muy recomendado.",
  },
  {
    name: "Gustavo Torres-R.",
    date: "Jan 23, 2018",
    rating: 5,
    text: "Great customer service and fast service. Smogged my Geo Metro the other day and will return with all my other cars. Highly recommended!",
    text_es: "Excelente servicio al cliente y muy rápido. El otro día hicieron el smog de mi Geo Metro y volveré con mis otros carros. ¡Muy recomendado!",
  },
  {
    name: "Jennifer Chapman",
    date: "Oct 23, 2020",
    rating: 5,
    text: "Quick and easy for a first-time customer of the day, even on a Saturday.",
    text_es: "Rápido y fácil siendo cliente por primera vez, incluso un sábado.",
  },
];

// Verified count from Yelp business profile (web-confirmed). Average rating left
// null until the exact live Google/Yelp average is confirmed (never fabricated).
export const REVIEW_META = {
  source: "Yelp",
  count: 46,
};
